import { BlueText } from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/NotificationData/styles'
import { GreenButton } from 'pages/NotifyEventPatient/styles'
import React, { useMemo } from 'react'
import { SubmitHandler, UseFormGetValues, UseFormHandleSubmit } from 'react-hook-form'
import { IoCloseSharp } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { LocationReducer } from 'types/location'
import { SectorReducer } from 'types/sector'
import { VariableReducer } from 'types/variable'
import { NotifyEventPatientType } from 'validator/notify_event_patient_validator'

interface INotificationConfirmation {
  handleSubmit: UseFormHandleSubmit<NotifyEventPatientType, undefined>
  submitForum: SubmitHandler<NotifyEventPatientType>
  getValues: UseFormGetValues<NotifyEventPatientType>
  close: () => void
}

const feedBackNotificationPatientMapper = (
    formValues: NotifyEventPatientType,
    variableSelector: VariableReducer,
    locationSelector: LocationReducer,
    sectorSelector: SectorReducer,
) => {
    const incidentSector = formValues.incident_sector
    const locationIncident = formValues.location_incident
    const dmgValue = formValues.damage_level
    const selectedDamageValue = variableSelector.variablesListDamageLevel
        ?.slice(1)
        .find((l) => l?.value === dmgValue)?.label
    const locationIncidentValue = locationSelector?.locationsList?.find(
        (l) => l?.sys_id === locationIncident
    )?.name
    const sectorSelectorValue = sectorSelector?.sectorsList?.find(
        (l) => l?.sys_id === incidentSector
    )?.u_name

    const getTurnLabelByValue = (value: string) => {
        const mapper: Record<string, string> = {
            not_known: 'Não informado',
            nighttime: 'Noturno  (19h - 6h59)',
            daytime: 'Diurno (7h - 18h59)'
        }
        return mapper[value] || value
    }

    const incidentTypeValue = variableSelector.variablesListIncidentType
        ?.slice(1)
        .find((l) => l?.value === formValues.incident_type)?.label

    const result = [
        {
            keyText: 'Título da notificação',
            valueText: formValues.incident_title
        },
        {
            keyText: 'Data da ocorrência',
            valueText: formValues.date_incident?.toLocaleDateString()
        },
        {
            keyText: 'Descrição do incidente',
            valueText: formValues.incident_description
        },
        // {
        //     keyText: 'Tipo do incidente',
        //     valueText: incidentTypeValue
        // },
        // {
        //     keyText: 'Classificação do Incidente',
        //     valueText: selectedDamageValue
        // },
        {
            keyText: 'Unidade',
            valueText: locationIncidentValue
        },
        {
            keyText: 'Setor notificado',
            valueText: sectorSelectorValue
        },
        {
            keyText: 'Turno',
            valueText: getTurnLabelByValue(formValues.shift_incident)
        },
        {
            keyText: 'Notificante',
            valueText: formValues.notification_type_toggle
                ? formValues.reporter_name
                : 'Anônimo'
        },
    ]

    return result.filter(item => item.valueText) // Remove itens vazios
}

export default function NotificationConfirmation({ handleSubmit, submitForum, getValues, close }: INotificationConfirmation) {

  //redux state
  const variableSelector: VariableReducer = useSelector(
    (state: RootReducerState) => state.variableReducers
  )
  const locationSelector: LocationReducer = useSelector(
    (state: RootReducerState) => state.locationReducers
  )
  const sectorSelector: SectorReducer = useSelector(
    (state: RootReducerState) => state.sectorReducers
  )

  const formValues = getValues()
  const infoMapper = useMemo(() => {
    return feedBackNotificationPatientMapper(formValues, variableSelector, locationSelector, sectorSelector)
  }, [formValues, variableSelector, locationSelector, sectorSelector])
  return (
    <div
      data-testid={"test-confirme-notification-modal"}
      className='md:pb-11 lg:w-[1022px]' >
      
      <div className='md:py-6 md:px-8 text-left'>
        <div className='flex items-center'>
          <BlueText className='text-lg'>Confirmação da notificação</BlueText>
          <div
            onClick={close}
            data-testid="test-close-icon"
            className=' cursor-pointer ml-auto'
          >
            <IoCloseSharp
              className="text-blueTheme h-8 w-8 p-1"
            />
          </div>
        </div>
        <p className="text-darkGray md:text-base text-xs">
          Confira o resumo da sua notificação. Caso precise alterar alguma informação, volte para o passo que desejar.
        </p>
      </div>
      <hr className={'border-[1px] md:block hidden  border-[#EBEDF2] mt-4 md:mt-0'} />
      <div className='md:px-8 md:mt-8 mt-5 text-left'>
        <div className='border border-[#EBEFF5] rounded-lg md:px-[33px] md:py-[26px] px-6 py-4'>
          <BlueText className='md:text-lg text-sm '>Resumo</BlueText>
          <div className='mt-4'>
            {
              infoMapper.map((info, idx) => {
                const hasExtraMarginText = ["Classificação do Incidente", "Unidade"]
                const topExtraMargin = hasExtraMarginText.includes(info.keyText) ? "mt-4" : ""
                return (
                  <div
                    key={idx}
                    className={`${topExtraMargin}`}
                  >
                    <NotificationFeedBackHelper
                      keyText={info.keyText}
                      valueText={info.valueText}
                    />
                  </div>
                )
              })
            }
          </div>
        </div>
        <form
          onSubmit={handleSubmit(submitForum)}
          className='mt-8'>
          <GreenButton onClick={close} className="w-full">
            <span className='text-white text-sm font-semibold	 leading-5'>Enviar notificação</span>
          </GreenButton>
        </form>
      </div>
    </div>
  )
}
export interface INotificationFeedBackHelperProps {
  keyText: string
  valueText: string
}
export const NotificationFeedBackHelper = ({ keyText, valueText, }: INotificationFeedBackHelperProps) => {
  return (
    <div className='flex md:flex-row flex-col md:gap-4 mb-1'>
      <span className='text-darkGray md:text-base text-xs'>{keyText}</span>
      <span className='text-darkGray font-semibold md:text-base text-xs'>{valueText}</span>
    </div>
  )
}

